import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { useI18n } from "@/i18n";

export default function CookieBanner() {
  const { t } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const ok = localStorage.getItem("mt_cookie");
    if (!ok) {
      // Delay so it doesn't cover the hero CTA on first paint
      const timer = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  const decide = (accept) => {
    localStorage.setItem("mt_cookie", accept ? "accept" : "decline");
    setVisible(false);
  };

  if (!visible) return null;
  return (
    <div
      data-testid="cookie-banner"
      role="dialog"
      aria-label="Cookie preferences"
      className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-sm z-[60] glass rounded-2xl p-4 md:p-5 shadow-2xl fade-in-up"
    >
      <button
        onClick={() => decide(false)}
        aria-label="Close"
        className="absolute top-2.5 right-2.5 text-zinc-500 hover:text-white transition-colors"
      >
        <X size={16} />
      </button>
      <p className="text-[13px] text-zinc-300 mb-4 leading-relaxed pr-6">{t("cookie.text")}</p>
      <div className="flex gap-2">
        <button onClick={() => decide(true)} data-testid="cookie-accept" className="btn-primary text-[11px] py-2 px-4">
          {t("cookie.accept")}
        </button>
        <button onClick={() => decide(false)} data-testid="cookie-decline" className="btn-outline text-[11px] py-2 px-4">
          {t("cookie.decline")}
        </button>
      </div>
    </div>
  );
}
